import React, { useEffect, useState } from 'react'
import { useGetLeaveTypesQuery } from '../api/getLeaveTypeApi';
import { cloneDeep } from 'lodash';
import { FormControl, InputLabel, Select, MenuItem, TextField, Button, Alert, Snackbar } from '@mui/material';
import { useGetEmployeeListQuery, useGetDropdownUsersQuery } from '../api/addEmployeeApi';
import { useCreateProfileQuery } from '../api/profileApi';
import { useGetEmployeeLeavesQuery, useLazyGetEmployeeLeaveInfoQuery } from '../api/employeeLeaves'
import axios from 'axios';
import { genericHeaders, serviceUrl } from '../utils/apiConfig';
import { getToken } from '../services/Token';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import Loader from "../Components/customComponents/customLoader"
import { Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import { useFetchRegularizationStatusMutation } from '../api/regularizationApi';
import dayjs from 'dayjs';
import { getMonthStartAndEndDates } from '../utils';

const SESSION_FIRST_HALF = "SESSION_1";
const SESSION_SECOND_HALF = "SESSION_2";
const HALF_DAY = 0.5;

const ApplyLeave = ({ onBehalf = false }) => {

    const form = {
      get_id: "",
      isActive: true,
      employeeId: "",
      fromDate: null,
      toDate: null,
      leaveType: "",
      days: 0,
      fromSession: SESSION_FIRST_HALF,
      toSession: SESSION_SECOND_HALF,
      leaveReason: "",
      reportingManagerIds: [],
      additionalProps: {
        additionalProp1: {},
        additionalProp2: {},
        additionalProp3: {},
      },
    };
    const [leaveType, setLeaveType] = useState([]);
    const [ccEmployees, setCcEmployees] = useState([]);
    const [employeeList, setEmployeeList] = useState([]);
    const [formData, setFormData] = useState(form);
    const [employee, setEmployee] = useState();
    const [leaveCount, setLeaveCount] = useState("-");
    const [ calendarDate, setCalendarDate ] = useState(new Date().toISOString().split('Z')[0]);
    const [loading, setLoading] = useState(false);
    const [ calendarLoading, SetCalendarLoading ] = useState(false);
    const [formErrors, setFormErrors] = useState({});
    const [ leaves,setLeaves ] = useState([]);
    const [ restrictedHoliday,setRestrictedHoliday] = useState("");
    const [ dialogOpen,setDialogOpen ] = useState(false);
    const [ oldLeaveCategory,setOldLeaveCategory ] = useState("")
    const [ optionalHolidays,setOptionalHolidays ] = useState([]);
    const [shiftsWeekOffData, setShiftsWeekOffData] = useState([]);
    const { startDate, endDate } = getMonthStartAndEndDates();
    const [snack, setSnack] = useState({
      open: false,
      error: false,
      message: "",
    });
    

    const loggedInId = getToken("Id");
    const [selectedEmployeeId, setSelectedEmployeeId] = useState("");
    const Id = onBehalf ? selectedEmployeeId : loggedInId;
    const { data: dropdownUsers = [] } = useGetDropdownUsersQuery(undefined, { skip: !onBehalf });
    const { currentData: employeeData, isSuccess: employeeDataSucess } =
      useCreateProfileQuery({ employeeId: `${Id}` }, { skip: !Id });
    const { data: leaveTypeData, isSuccess: leaveTypeSuccess } =
      useGetLeaveTypesQuery();
    const { data: employeeListData, isSuccess: employeeListSuccess } =
      useGetEmployeeListQuery();
    const { currentData: employeeLeaveData, isSucces: employeeLeaveSuccess } =
      useGetEmployeeLeavesQuery({ employeeId: `${Id}` }, { skip: !Id });
    const [ getEmployeeLeaveInfo, leaveInfo] = useLazyGetEmployeeLeaveInfoQuery();
    const [fetchShifStatus, { data: shiftStatusData , isSuccess:isShiftStatusSuccess , isError: isShiftStatusError}] = useFetchRegularizationStatusMutation();
    useEffect(() => {
      if (leaveTypeData) {
        let newData = cloneDeep(leaveTypeData);
        setLeaveType(newData);
        newData.forEach((item,i) => {
          if (item.isRestrictedHolidayCategory) {
            setRestrictedHoliday(item._id);
          }
        })
        newData.every((item) => {
          if(!item.isRestrictedHolidayCategory){
            setOldLeaveCategory(item._id);
            return false;
          }
          return true;
        })
      }
      if (employeeListData) {
        let newData = cloneDeep(employeeListData);
        newData = newData.filter((data) => data.id !== Id);
        setEmployeeList(newData);
      }
      if (employeeData) {
        let newData = cloneDeep(employeeData);
        setEmployee(newData);
      }
      if (employeeLeaveData) {
        let newData = cloneDeep(employeeLeaveData);
        let count = displayCount(formData, newData.leaves);
        setLeaveCount(count);
      }
    }, [
      leaveTypeSuccess,
      employeeListSuccess,
      employeeDataSucess,
      employeeLeaveSuccess,
      formData,
      employeeData,
      employeeLeaveData,
    ]);
    useEffect(() => {
      if(calendarDate && Id){
       getEmployeeLeaveInfo({ employeeId: `${Id}`,date: `${calendarDate}` })
      }
    },[calendarDate, Id])
    useEffect(() => {
      if(leaveInfo.isSuccess){
        setLeaves(leaveInfo.data);
        SetCalendarLoading(false);
      }
    }, [leaveInfo.data]);
    const getCalendarDetails = async () => {
      try{
        let url = `${serviceUrl}/api/holidayCalender/getHolidays?restrictedHolidayId=${restrictedHoliday}`
        let response = await axios.get(url,{headers: genericHeaders()})
        if(response.status === 200){
          let newData = response.data;
          newData = newData.filter((item) => item.leaveType === "OPTIONAL");
          setOptionalHolidays(newData);
          setLoading(false)
        }
      }catch(error){
        setLoading(false);
        handleSnackOpen(true,true,"Something Went wrong")
        console.error(error)
      }
    }
    const dateDifference = (fromDate, toDate) => {
        const start = dayjs(fromDate);
        const end = dayjs(toDate);
        const totalDays = end.diff(start, "days") + 1;

        const numSundaysMondays = [...Array(totalDays).keys()].filter((index) => {
          const currentDate = start.add(index, "days");
          const dayOfWeek = currentDate.day();
          return shiftsWeekOffData?.includes(dayOfWeek);
        }).length;

        const leaveDays = totalDays - numSundaysMondays;
        return leaveDays;
    };

    const displayCount = (data, leaves) => {
      let matchedData = leaves.find(
        (item) => data.leaveType === item.leaveType
      );
      return matchedData?.currentAvailableLeaves || "0";
    };

    const handleDate = (evt, type) => {
      let data = { ...formData };
      const localDate = dayjs(evt).toISOString();
      if(type === "from") {
        data.fromDate = localDate;
      }else if(type === "to") {
        data.toDate = localDate;
      }
      setFormData(data);
    };

    const dateValidator = (date) => {
      const inputDate = new Date(date);
      const localDate = new Date(inputDate.getTime() + 330 * 60 * 1000);
      return localDate.toISOString();
    }

    const handleForm = (evt) => {
      let data = { ...formData };
      if(evt.target.name === "leaveType" && evt.target.value === restrictedHoliday){
        setLoading(true);
        const calendarId = employee?.professionalDetails?.holidayCalender;
        getCalendarDetails();
        setDialogOpen(true)
      }
      else{
      data[evt.target.name] = evt.target.value;
      }
      setFormData(data);
    };

    const handleCcEmployee = (evt) => {
      setCcEmployees(evt.target.value);
    };
    const handleEmployeeChange = (evt) => {
      setSelectedEmployeeId(evt.target.value);
      setFormData(form);
      setCcEmployees([]);
      setFormErrors({});
      setEmployee(undefined);
      setLeaveCount("-");
      setLeaves([]);
      setShiftsWeekOffData([]);
    };
    const isTargetReady = !onBehalf || (!!employee && !!employeeLeaveData);
    const handleSnackOpen = (open,error,message) => {
      let snackData = {...snack};
      snackData.open = open;
      snackData.error = error;
      snackData.message = message;
      setSnack(snackData);
    };
    const handleSnackClose = () => {
      setSnack(false);
    }; 
    const handleMonthChange = (evt) => {
      SetCalendarLoading(true);
      let date = dayjs(evt).startOf('day').format("YYYY-MM-DDTHH:mm:ss.SSS");
      setCalendarDate(date);
    }
    
    const isHalfDaySession = (session) =>
      session === SESSION_FIRST_HALF || session === SESSION_SECOND_HALF;

    // Days calculation matching greytHR:
    // fromSession=SECOND_HALF → start day counts as 0.5
    // toSession=FIRST_HALF    → end day counts as 0.5
    // Same date + half session on either side → 0.5 days total
    const computeDays = (fromDate, toDate, fromSession, toSession) => {
      if (!fromDate || !toDate) return 0;
      const base = dateDifference(fromDate, toDate);
      const startDeduction = fromSession === SESSION_SECOND_HALF ? HALF_DAY : 0;
      const endDeduction   = toSession   === SESSION_FIRST_HALF  ? HALF_DAY : 0;
      return Math.max(HALF_DAY, base - startDeduction - endDeduction);
    };

    const computedDays = () =>
      computeDays(formData.fromDate, formData.toDate, formData.fromSession, formData.toSession);

    const handleSession = (field, value) => {
      const data = { ...formData, [field]: value };
      if (field === "fromSession" && isHalfDaySession(value) && data.toDate) {
        data.toDate = data.fromDate;
      }
      setFormData(data);
    };

    const handleSubmit = async () => {
      const errors = {};
      if (!formData.leaveType) errors.leaveType = "Please select a leave type";
      if (!formData.fromDate) errors.fromDate = "Please select a from date";
      if (!formData.toDate) errors.toDate = "Please select a to date";
      if (onBehalf && !selectedEmployeeId) errors.employee = "Please select an employee";
      if (Object.keys(errors).length > 0) {
        setFormErrors(errors);
        return;
      }
      if (!isTargetReady) return;
      const requestedDays = computeDays(formData.fromDate, formData.toDate, formData.fromSession, formData.toSession);
      if (requestedDays > leaveCount) {
        handleSnackOpen(true, true, `Insufficient balance. You have ${leaveCount} day(s) but requested ${requestedDays} day(s).`);
        return;
      }
      setFormErrors({});
      setLoading(true);
      let data = {...formData};
      data.reportingManagerIds = ccEmployees;
      data.employeeId = employee._id;
      data.days = requestedDays;
      if (requestedDays <= HALF_DAY) {
        data.toDate = data.fromDate;
      }
      data.fromDate = dayjs(data.fromDate).startOf('day').format("YYYY-MM-DDTHH:mm:ss.SSS[Z]");
      data.toDate = dayjs(data.toDate).endOf('day').format("YYYY-MM-DDTHH:mm:ss.SSS[Z]");
      try {
        delete data.attachment;
        let response = await axios.post(
          `${serviceUrl}/api/leaveTransaction/submitLeave`,
          data,
          { headers: genericHeaders() }
        );
        // Fix 3 & 4: always call setLoading(false) regardless of response status
        setLoading(false);
        if (response.status === 201) {
          setFormData(form);
          setCcEmployees([]);
          handleSnackOpen(true, false, onBehalf
            ? `Leave applied for ${dropdownUsers.find((u) => u.employeeId === selectedEmployeeId)?.name || "the employee"}`
            : "Leave Applied Successfully");
          setCalendarDate(new Date().toISOString().split('Z')[0]);
        }
      } catch (err) {
        console.error(err);
        setLoading(false);
      }
    };
    const fromDateDisabled = (date) => {
      const local = dayjs(date);
      if (formData.toDate) {
        const toDate = dayjs(formData.toDate);
        const day = local.day();
        // let activeDays = toDate;
        // let count = 0;
        // while (count < 2) {
        //   activeDays = activeDays.subtract(1, 'day');
        //   if (activeDays.day() !== 0 && activeDays.day() !== 1) {
        //     count += 1;
        //   }
        // }
        if (local.isAfter(toDate) || shiftsWeekOffData.includes(day)) {
          return true;
        } 
      }
      if(shiftsWeekOffData.includes(local.day())){
        return true;
      }
      const dateString = local.startOf('day').format('YYYY-MM-DDTHH:mm:ss');
      return leaves.some((leave) => leave.date === dateString && leave.isOnLeave);
    };
    const toDateDisabled = (date) => {
      const local = dayjs(date);
      if (formData.fromDate) {
        const from = dayjs(formData.fromDate);
        const day = local.day();
        //let activeDays = from;
        // let count = 0;
        // while (count < 2) {
        //   activeDays = activeDays.add(1, 'day');
        //   if (activeDays.day() !== 0 && activeDays.day() !== 1) {
        //     count += 1;
        //   }
        // }=~
        if (local.isBefore(from) || shiftsWeekOffData.includes(day)) {
          return true;
        }
      }
      if (shiftsWeekOffData.includes(local.day())) {
        return true;
      }
      const dateString = local.startOf('day').format('YYYY-MM-DDTHH:mm:ss');
      return leaves.some((leave) => leave.date === dateString && leave.isOnLeave);
    };
    const handleRestrictedLeaveApply = async (leave) => {
      let data = {
        get_id: "",
        isActive: true,
        employeeId: "",
        fromDate: null,
        toDate: null,
        leaveType: "",
        days: 0,
        leaveReason: "",
        reportingManagerIds: [],
        additionalProps: {
          additionalProp1: {},
          additionalProp2: {},
          additionalProp3: {},
        },
      }
      handleClose();
      setLoading(true);
      data.employeeId = Id;
      data.fromDate = dayjs(leave.date).startOf('day').format("YYYY-MM-DDTHH:mm:ss.SSS[Z]")
      data.toDate = dayjs(leave.date).endOf('day').format("YYYY-MM-DDTHH:mm:ss.SSS[Z]")
      data.leaveType = restrictedHoliday
      data.days = 1
      try{
        let response = await axios.post(
          `${serviceUrl}/api/leaveTransaction/submitLeave`,
          data,
          { headers: genericHeaders() });
          if(response.status === 201){
            handleClose();
            setLoading(false);
            handleSnackOpen(true,false,"Leave Applied Successfully");
          }
      }catch (error){
        console.error(error)
        setLoading(false);
        handleSnackOpen(true,true,"Something Went Wrong");
      }
    }
    const handleClose = () => {
      setDialogOpen(false);
      let newData = {...formData};
      newData.leaveType = oldLeaveCategory;
      setFormData(newData);
    }
    useEffect(()=>{
      if (!Id) return;
      const body = {
        employeeId: Id,
        fromDate: startDate,
        toDate: endDate,
      };
      fetchShifStatus(body)
    },[Id])
    useEffect(()=>{
      if(shiftStatusData && isShiftStatusSuccess){
        let newData = cloneDeep(shiftStatusData?.data);
        const weekOffCodes = new Set(newData?.filter((each) => each?.status === 203)?.map(e => (e?.weekday === 107) ? 0 : e?.weekday - 100))
        setShiftsWeekOffData([...weekOffCodes]);
      }
    },[isShiftStatusSuccess, shiftStatusData])
  return (
    <>
      <div className="w-full relative">
        <div className="w-1/2">
          <p className="absolute top-5 right-10 text-xl">
            Leave Balance : {leaveCount}
          </p>
        </div>
        {loading && (<Loader/>)}
        <div className="my-10 mx-10 w-1/2">
          <Snackbar
            anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
            open={snack.open}
            autoHideDuration={2000}
            onClose={handleSnackClose}
          >
            <Alert
              severity={snack.error ? "error" : "success" }
              variant="filled"
              onClose={handleSnackClose}
            >
              {snack.message}
            </Alert>
          </Snackbar>

          <Dialog
            open={dialogOpen}
            onClose={handleClose}
            maxWidth="lg" 
            fullWidth
          >
            <DialogTitle id="alert-dialog-title">Restricted Holiday</DialogTitle>
            <DialogContent>
              <div className='grid grid-cols-3 gap-5'>
                {optionalHolidays.map((item) => {
                  const leaveDate = new Date(item.date);
                  const today = new Date();
                  const differenceInMs = leaveDate - today;
                  const differenceInDays = Math.floor(differenceInMs / (1000 * 60 * 60 * 24));
                  return (<div className='px-5 py-3 rounded-lg border border-blue-500'>
                  <div className='flex flex-col'>
                   <h3 className='text-4xl font-semibold'>{item.occation}</h3>
                   <p className='text-lg'>{dayjs(item.date).format("DD MMM YYYY")}</p>
                  </div>
                  <div className='flex items-end justify-end'>
                    {differenceInDays < 3 && differenceInDays > 0 && leaveCount > 0 ? ( item.isApplied ? <p className='text-blue-400 cursor-default'>Applied</p> : <p className='text-blue-400 cursor-pointer' onClick={() => handleRestrictedLeaveApply(item)}>Apply</p>): <></>}
                    
                  </div>
                </div>)})}
              </div>
            </DialogContent>
            <DialogActions>
              <Button onClick={handleClose}>CANCEL</Button>
            </DialogActions>
          </Dialog>


          <h3 className="text-xl">{onBehalf ? "Apply Leave on Behalf" : "Apply Leave"}</h3>

          {onBehalf && (
            <div className="my-8">
              <FormControl className="w-5/12" error={!!formErrors.employee}>
                <InputLabel id="on-behalf-employee">Employee *</InputLabel>
                <Select
                  labelId="on-behalf-employee"
                  label="Employee *"
                  value={selectedEmployeeId}
                  onChange={handleEmployeeChange}
                  MenuProps={{ sx: { '& .MuiList-root': { maxHeight: 300 } } }}
                >
                  {dropdownUsers.map((user) => (
                    <MenuItem value={user.employeeId} key={user.employeeId}>
                      {user.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </div>
          )}

          {/* Leave Type */}
          <div className="my-8">
            <FormControl className="w-5/12" error={!!formErrors.leaveType}>
              <InputLabel id="leave-type">Leave Type *</InputLabel>
              <Select
                labelId="leave-type"
                label="Leave Type *"
                name="leaveType"
                value={formData.leaveType}
                onChange={(e) => { handleForm(e); setFormErrors((prev) => ({ ...prev, leaveType: "" })); }}
                MenuProps={{ sx: { '& .MuiList-root': { maxHeight: 300 } } }}
              >
                {leaveType.filter((item) => !(onBehalf && item.isRestrictedHolidayCategory)).map((item) => (
                  <MenuItem value={item._id} key={item._id}>
                    {item.leaveCategory}
                  </MenuItem>
                ))}
              </Select>
              {formErrors.leaveType && <p className="text-xs text-red-500 mt-1 ml-1">{formErrors.leaveType}</p>}
            </FormControl>
          </div>

          {/* From Date + Session 1 | To Date + Session 2 — side by side */}
          <div className="flex items-start gap-6 mb-6">
            <div className="flex items-center gap-3">
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  label="From Date"
                  format="DD/MM/YYYY"
                  className="w-44"
                  value={formData.fromDate ? dayjs(formData.fromDate) : null}
                  onChange={(e) => {
                    const localDate = dayjs(e).toISOString();
                    let data = { ...formData };
                    data.fromDate = localDate;
                    setFormData(data);
                    setFormErrors((prev) => ({ ...prev, fromDate: "" }));
                  }}
                  onOpen={() => SetCalendarLoading(false)}
                  shouldDisableDate={(date) => fromDateDisabled(date)}
                  disabled={isShiftStatusError}
                  loading={calendarLoading}
                  onMonthChange={handleMonthChange}
                  slotProps={{ textField: { readOnly: true, error: !!formErrors.fromDate, helperText: formErrors.fromDate || "" } }}
                />
              </LocalizationProvider>
              <FormControl sx={{ minWidth: 140 }}>
                <InputLabel id="from-session-label">Session 1</InputLabel>
                <Select
                  labelId="from-session-label"
                  label="Session 1"
                  value={formData.fromSession}
                  onChange={(e) => handleSession("fromSession", e.target.value)}
                >
                  <MenuItem value={SESSION_FIRST_HALF}>Session 1</MenuItem>
                  <MenuItem value={SESSION_SECOND_HALF}>Session 2</MenuItem>
                </Select>
              </FormControl>
            </div>

            <div className="flex items-center gap-3">
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  label="To Date"
                  format="DD/MM/YYYY"
                  className="w-44"
                  value={formData.toDate ? dayjs(formData.toDate) : null}
                  onChange={(e) => {
                    const localDate = dayjs(e).toISOString();
                    let data = { ...formData };
                    data.toDate = localDate;
                    setFormData(data);
                    setFormErrors((prev) => ({ ...prev, toDate: "" }));
                  }}
                  onOpen={() => SetCalendarLoading(false)}
                  disabled={isShiftStatusError}
                  onMonthChange={handleMonthChange}
                  shouldDisableDate={(date) => toDateDisabled(date)}
                  slotProps={{ textField: { readOnly: true, error: !!formErrors.toDate, helperText: formErrors.toDate || "" } }}
                />
              </LocalizationProvider>
              <FormControl sx={{ minWidth: 140 }}>
                <InputLabel id="to-session-label">Session 2</InputLabel>
                <Select
                  labelId="to-session-label"
                  label="Session 2"
                  value={formData.toSession}
                  onChange={(e) => handleSession("toSession", e.target.value)}
                >
                  <MenuItem value={SESSION_FIRST_HALF}>Session 1</MenuItem>
                  <MenuItem value={SESSION_SECOND_HALF}>Session 2</MenuItem>
                </Select>
              </FormControl>
            </div>
          </div>

          {/* Total Days */}
          {(formData.fromDate && formData.toDate) && (
            <div className="mb-6 flex items-center gap-2">
              <span className="text-sm text-gray-500">Total Days:</span>
              <span className="font-semibold text-blue-600">{computedDays()}</span>
              {computedDays() <= HALF_DAY && (
                <span className="text-xs px-2 py-0.5 rounded-full bg-amber-100 text-amber-700 border border-amber-200 font-medium">
                  Half Day
                </span>
              )}
            </div>
          )}

          {/* Manager */}
          <div className="mb-6">
            <TextField
              label="Manager"
              variant="outlined"
              className="w-5/12"
              value={
                (() => {
                  const metaKeys = ["count","size","empty","length"];
                  return Object.entries(employee?.managersMap || {})
                    .filter(([k, v]) => !metaKeys.includes(k.toLowerCase()) && typeof v === "string" && v.trim().length > 0)
                    .map(([k]) => k)
                    .join(", ");
                })()
              }
              disabled
            />
          </div>

          {/* Reason */}
          <div className="mb-6">
            <TextField
              label="Reason"
              name="leaveReason"
              variant="outlined"
              onChange={handleForm}
              className="w-5/12"
              value={formData.leaveReason}
              multiline
              rows={3}
            />
          </div>

        </div>
      </div>
      <div className="flex items-end justify-end mt-20 space-x-10 mx-20">
        <Button
          variant="contained"
          onClick={() => { setFormData(form); setCcEmployees([]); setFormErrors({}); }}
          size="large"
        >
          Reset
        </Button>
        <Button
          variant="contained"
          size="large"
          onClick={handleSubmit}
          disabled={loading || !isTargetReady || !formData.leaveType || !formData.fromDate || !formData.toDate || computedDays() > leaveCount}
        >
          Apply Leave
        </Button>
      </div>
    </>
  );
}

export default ApplyLeave